export const earningColumns = [
  { field: "job_id", label: "Job ID" },
  { field: "date", label: "Date" },
  { field: "amount", label: "Amount" },
  { field: "status_tag", label: "Status" },
  { field: "type", label: "Type" },
  // { field: 'estimated_payout', label: 'Estimated Payout' }
];

export const earningData = [
  {
    job_id: "JOB-1001",
    date: "2025-07-20",
    amount: "$50.00",
    status_tag: "Completed",
    type: "Delivery",
    estimated_payout: "$45.00"
  },
  {
    job_id: "JOB-1002",
    date: "2025-07-21",
    amount: "$75.00",
    status_tag: "Pending",
    type: "Pickup",
    estimated_payout: "$67.50"
  },
  {
    job_id: "JOB-1003",
    date: "2025-07-22",
    amount: "$60.00",
    status_tag: "Completed",
    type: "Delivery",
    estimated_payout: "$54.00"
  },
  {
    job_id: "JOB-1004",
    date: "2025-07-23",
    amount: "$40.00",
    status_tag: "Cancelled",
    type: "Pickup",
    estimated_payout: "$0.00"
  },
  {
    job_id: "JOB-1005",
    date: "2025-07-24",
    amount: "$85.00",
    status_tag: "Completed",
    type: "Delivery",
    estimated_payout: "$76.50"
  },
  {
    job_id: "JOB-1006",
    date: "2025-07-25",
    amount: "$55.00",
    status_tag: "Pending",
    type: "Pickup",
    estimated_payout: "$49.50"
  },
  {
    job_id: "JOB-1007",
    date: "2025-07-26",
    amount: "$95.00",
    status_tag: "Completed",
    type: "Delivery",
    estimated_payout: "$85.50"
  }
];


export const historyColumns = [
  { field: "job_id", label: "Job ID" },
  { field: "date", label: "Date",filter: true },
  { field: "customer", label: "Customer" ,filter: true},
  { field: "location", label: "Location",filter: true },
  { field: "Earnings", label: "earnings" },
  { field: "status_tag", label: "Status" },
  { field: 'action', label: 'Feedback' }

];
export const historyData = [
  {
    job_id: 'J101',
    date: '2025-07-01',
    customer: 'Anil Sharma',
    location: 'Mumbai',
    Earnings: 120,
    status_tag: 'Delivered',
    action: 'View',
    score: 4,
    content:"good delivery service"
  },
  {
    job_id: 'J102',
    date: '2025-06-10',
    customer: 'Neha Sinha',
    location: 'Pune',
    Earnings: 150,
    status_tag: 'Delivered',
    action: 'View',
      score: 3,
    content:"late delivery service"
  },
  {
    job_id: 'J103',
    date: '2025-01-15',
    customer: 'Amit Patil',
    location: 'Delhi',
    Earnings: 100,
    status_tag: 'Cancelled',
    action: 'View',
      score: 1,
    content:"Back behaviour"
  }
];
